import hashtagStrategy from './hashtag-strategy';

export { default as extractHashtags } from './extract-hashtags';

export default function HashtagPlugin({ Hashtag }) {
  return {
    decorators: [
      {
        component: Hashtag,
        strategy: hashtagStrategy,
      },
    ],
  };
}



// WEBPACK FOOTER //
// ./app/components/text-editor/plugins/hashtag/index.js